<div class="investment-buildings-editor" [formGroup]="form">
  <div class="investment-buildings-editor__actions">
    <button pButton type="button" severity="secondary" (click)="addBuilding()" [disabled]="disabled">
      <span class="pi pi-plus" aria-hidden="true"></span>
      <span>Dodaj budynek</span>
    </button>
  </div>

  @if (buildingsArray.length === 0) {
    <p-message severity="info">Budynki można dodać teraz albo później.</p-message>
  }

  <div formArrayName="buildings" class="investment-buildings-editor__list">
    @for (building of buildingsArray.controls; track building; let buildingIndex = $index) {
      <div class="building-card" [formGroupName]="buildingIndex">
        <div class="building-card__header">
          <div class="building-card__code">
            <label [for]="'building-code-' + buildingIndex">Kod budynku</label>
            <input
              pInputText
              [id]="'building-code-' + buildingIndex"
              formControlName="buildingCode"
              class="w-full"
              placeholder="np. B1"
            />
            @if (isControlInvalid(building.get('buildingCode'))) {
              <small class="field-error">Kod budynku jest wymagany.</small>
            }
          </div>

          <button
            pButton
            type="button"
            severity="danger"
            [text]="true"
            (click)="removeBuilding(buildingIndex)"
            [disabled]="disabled"
          >
            <span class="pi pi-trash" aria-hidden="true"></span>
            <span>Usuń</span>
          </button>
        </div>

        <app-building-address-list-editor
          [addressesArray]="getAddressesArray(buildingIndex)"
          [disabled]="disabled"
          [title]="'Adresy budynku'"
          [fieldIdPrefix]="'investment-building-' + buildingIndex"
          [removeButtonLabel]="'Usuń adres'"
          [removeDisabledTooltip]="'Dodaj co najmniej dwa adresy, aby usunąć jeden z nich.'"
          [preservePersistedAddresses]="false"
          (addAddress)="addAddress(buildingIndex)"
          (removeAddress)="removeAddress(buildingIndex, $event)"
        />
      </div>
    }
  </div>
</div>
